import { createBrowserRouter, Navigate } from "react-router";

import { AppLayout } from "./layouts/AppLayout";
import {
  RequireAuth,
  RequireCurrentConsents,
  RequireTenant,
  RequireVerifiedEmail,
} from "./lib/guards";
import { ConsentsPage } from "./pages/account/ConsentsPage";
import { ForgotPasswordPage } from "./pages/auth/ForgotPasswordPage";
import { LoginPage } from "./pages/auth/LoginPage";
import { ReconsentPage } from "./pages/auth/ReconsentPage";
import { RegisterPage } from "./pages/auth/RegisterPage";
import { ResetPasswordPage } from "./pages/auth/ResetPasswordPage";
import { VerifyEmailPage } from "./pages/auth/VerifyEmailPage";
import { HomePage } from "./pages/home/HomePage";
import { InvitationPage } from "./pages/invitations/InvitationPage";
import { TenantsPage } from "./pages/tenants/TenantsPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  // Doğrulama ekranı oturum GEREKTİRMEZ: kullanıcı e-postadaki bağlantıya başka bir
  // tarayıcıdan da tıklayabilir.
  { path: "/verify-email", element: <VerifyEmailPage /> },
  // Davet ekranı da oturum GEREKTİRMEZ (CLOS-74 `[035]`): davet edilen kişinin henüz
  // hesabı olmayabilir ve hangi organizasyona çağrıldığını kaydolmadan önce görmeli.
  // `RequireAuth` arkasında olsaydı davetli /login'e atılır, token yolda kaybolurdu —
  // rota hiç yokken catch-all'ın yaptığının aynısı.
  { path: "/davet", element: <InvitationPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <RequireVerifiedEmail />,
        children: [
          // Yeniden onay ekranı onay KAPISININ DIŞINDA: içeride olsaydı kullanıcı kendi
          // çıkışına ulaşamaz, sonsuz yönlendirmeye girerdi.
          { path: "/consents", element: <ReconsentPage /> },
          {
            element: <RequireCurrentConsents />,
            children: [
              { path: "/tenants", element: <TenantsPage /> },
              // Onay geçmişi HESAP düzeyindedir, firmaya bağlı değil: `RequireTenant`
              // arkasında dursaydı, henüz firma seçmemiş bir kullanıcı kendi hukuki
              // kayıtlarını göremezdi.
              { path: "/onaylarim", element: <ConsentsPage /> },
              {
                element: <RequireTenant />,
                children: [
                  {
                    path: "/app",
                    element: <AppLayout />,
                    // Ürün modülleri henüz yok: ilk sözleşme ekranı EP06 kartlarıyla gelecek.
                    children: [{ index: true, element: <HomePage /> }],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  { path: "/", element: <Navigate to="/app" replace /> },
  { path: "*", element: <Navigate to="/" replace /> },
]);
